/* 日期：2019年1月11日 接口迁移 新的接口 去掉initid 改为系统id */

import store from "../store/index";
import pymonitor from "./monitor";
let host = process.env.VUE_APP_host;
let login = host + "uc/api/user/login";
// 获取绑定公众号链接
let getauthurl = host + "jczl/api/wechat/authurl";
let getQrParam = host + "jczl/api/system/webapp/param"; // 获取登录二维码
let sendRandomByPhone = host + "base/base/identifyingcode/sendRandomByPhone"; // 获取登录短信验证码
// 判断用户登录
let checkManager = host + "jczl/api/system/goto";
// 扫描二维码登录
let loginByQRcode = host + "jczl/api/system/login/qrcode";

let hujicard = host + "thirditf/api/estate/getHouseholdRegisterInfo";
let hujian = host + "thirditf/api/dataShare/getLicenseFileObj";

/* --------------------- 注册行政区域 BEGIN --------------------- */
// 查询get 创建post 行政区域
let register = host + `jczl/api/system/community/register`;
/* --------------------- 注册行政区域 END --------------------- */

/* --------------------- 基本设置 BEGIN --------------------- */
// 查询是否绑定公众号
let queryAuth = host + "jczl/api/wechat/gzh";
// 获取公众号信息
let get = host + "jczl/api/wechat/gzh";
// 注销公众号
let deleteGzh = host + "jczl/api/wechat/gzh";
// 获取 修改 行政区域信息
let community = host + `jczl/api/system/community`;
// 获取公众号设置的当前菜单 get
let getMenu = host + "jczl/api/wechat/menu";
// 保存公众号设置的当前菜单 post
let saveMenu = host + "jczl/api/wechat/menu";
// 获取公众号设置的 小程序列表
let listmenuurl = host + "jczl/api/wechat/gzh/menuurl";
// 获取关注自动回复
let reply = host + `jczl/api/wechat/reply`;
/* --------------------- 基本设置 END --------------------- */

// let uploadImg = host + 'base/base/oss/uploadImg';
let uploadImg = host + "base/base/oss/uploadImg64";
let uploadFile = host + `base/base/oss/upload`;

// 获取所有管理员
let allAdmin = () => {
  return host + "jczl/api/manager/list";
};
// 删除管理员
let delAdmin = () => {
  return host + "jczl/api/manager/delete";
};
// 获取管理员标签
let labelAdmin = () => {
  return host + "jczl/api/label/manager";
};
// 添加管理员
let saveAdmin = () => {
  return host + "jczl/api/manager/save";
};
let getSysPic = () => {
  return host + "jczl/api/community/pic";
};
let getZone = () => {
  return host + "jczl/api/manager/zone";
};
/* 新增微支部/微社区 */
let saveOrg = () => {
  return host + "jczl/api/zone";
};
/* 获取微支部 微社区列表 */
let getOrg = () => host + `jczl/api/zone`;
// 查询微社区、微支部数据集合
let getAllZone = () => {
  return host + "jczl/api/zone";
};
/* ============= 社区应用 BEGIN ============= */
/* 活动 */
// 添加修改活动
let activitySend = host + `jczl/api/activity`;
// 获取活动列表
let getActivity = host + `jczl/api/activity/list`;
// 删除撤销活动
let activeDel = activityId => host + `jczl/api/activity/${activityId}/delete`;
// 活动详情
let getActiveDetail = activityId =>
  host + `jczl/api/activity/${activityId}/detail`;

// 获取活动参与人
let getActivityPeople = host + `jczl/api/activity/people/list`;
// 获取活动图片列表
let getActivityPicList = host + `jczl/api/activity/pic/list`;
// 获取社区下 该活动 没有签到的人
let people4unsign = host + `jczl/api/activity/people4unsign/list`;
// 活动签到
let activitySign = activityId => host + `jczl/api/activity/${activityId}/sign`;
// 删除报名人 签到人
let delApplyOrSign = recordId => host + `jczl/api/activity/${recordId}/people`;
// 保存活动相册图片
let saveActivityPic = host + `jczl/api/activity/pic`;
// 删除活动相册图片
let delActivityPic = host + `jczl/api/activity/pic`;

// 查询各个社区下的活动数量
let activityCount = host + `jczl/api/community/activity/count`;
// 查询各个社区下的 报名签到人数
let activitySignCount = host + `jczl/api/community/activity/apply/sign/count`;
// 查询各个社区的 积分排名
let scoreRank = host + `jczl/api/community/activity/charts/score`;
// 导出活动数量
let activityCountExport = host + `jczl/api/community/activity/count/export`;
// 导出签到报名人数
let applySignCountExport =
  host + `jczl/api/community/activity/apply/sign/count/export`;
// 导出活动积分数量
let activityScoreExport =
  host + `jczl/api/community/activity/charts/score/export`;
// 统计每个社区已完成、未完成事件汇总--事件柱形图
let eventChart = host + `jczl/event/jczlevent/charts/count`;
// 事件统计图导出
let eventChartExport = host + `jczl/event/jczlevent/charts/count/export`;
// 事件办理满意度数据集合
let eventSatisfaction = host + `jczl/event/jczlevent/satisfaction`;
// 事件办理满意度导出
let eventSatisfactionExport = host + `jczl/event/jczlevent/satisfaction/export`;
// 事件办理效率数据集合
let eventEfficiency = host + `jczl/event/jczlevent/efficiency`;
// 事件办事效率导出
let eventEfficiencyExport = host + `jczl/event/jczlevent/efficiency/export`;
// 重置活动二维码
let reloadQrcode = activityId =>
  host + `jczl/api/activity/${activityId}/qrcode`;
/* ============= 社区应用 END ============= */

/* ============= 用户管理 BEGIN =============  */
/* 用户通用 */
// 修改居民属性
let updateUserAttr = host + `jczl/api/miniprogram/user/attr`;
/* 居民 */
// 获取居民页 右侧筛选标签
let resident = () => host + `jczl/api/label/resident`;
// 获取居民列表 可加入筛选条件 post
let residentList = () => host + `jczl/api/resident/list`;
// 居民用户拖曳到分类标签 post
let sortToLabel = () => host + `jczl/api/resident/label`;
// 修改/审核居民信息接口
let residentCheck = () => host + `jczl/api/resident/insert`;
// 获取绑定用户的二维码
let bindQrcode = host + `jczl/api/resident/bind/qrcode`;
// 删除居民、社工接口
let deletePeople = unionId => host + `jczl/api/community/${unionId}/people`;
// 删除绑定的微社区微支部
let deleteUserZone = unionId => host + `jczl/api/resident/${unionId}/zone`;

/* 企业 */
let importFile = host + `jczl/api/company/import`;
// let importFile = host + `base/base/oss/upload`
// 居民导入
let importCitizen = host + "jczl/api/resident/import";
/* 社工 */
// 获取社工列表 可加入筛选条件 post
let workList = () => host + `jczl/api/worker/list`;
// 获取社工页 右侧筛选标签
let worker = () => host + `jczl/api/label/worker`;
// 获取社工详情
let workerDetail = unionId => host + `jczl/api/worker/${unionId}/detail`;
// 获取社区或企业列表
let belongList = () => host + `jczl/api/worker/belong`;
// 修改/审核社工信息接口 / 添加社工
let workerCheck = () => host + `jczl/api/worker`;
// 获取可以添加为社工的人员集合(实名认证通过的非社工)
let workerList4add = host + "jczl/api/worker/list4add";
// 居民用户拖曳到分类标签 post
let sortToWorkerLabel = () => host + `jczl/api/worker/label`;

// 获取所在社区所属街道及街道下其他社区
let getOrgAll = host + "jczl/api/community/borther/children";
// 导出居民统计数据
let downloadUserStatics = (communityId, countType) =>
  host + `jczl/api/resident/${communityId}/${countType}/list4count/export`;
// 居民统计模块接口
let getUserStatics = (communityId, countType) =>
  host + `jczl/api/resident/${communityId}/${countType}/list4count`;
/* =============  用户管理 END =============  */

/* =============  微支部 微社区 BEGIN ============= */
// 获取微支部 微社区详情
let zoneInfo = zoneId => host + `jczl/api/zone/${zoneId}/detail`;
// 获取物业委员会详细信
let committeeInfo = host + "jczl/api/zone/property/committee";
// 添加微支部微社区图片接口
let zonePic = () => host + `jczl/api/zone/pic`;
// 查询当前可以添加为负责人的用户集合
let zoneNoLeader = zoneId => host + `jczl/api/zone/${zoneId}/noleader`;
// 获取可以添加到当前网格的网格长人员集合(从当前社区居民下筛选)
let gridUser = host + `jczl/api/grid/user/list4add`;
// 获取可以添加当前服务站的人
let stationUser = host + "jczl/api/service-station/user/list4add";
// 新增修改小区服务站信息
let addStation = host + "jczl/api/service-station";
// 删除小区服务站信息
let delStation = id => host + `jczl/api/service-station/delete?idList=${id}`;
// 添加修改微支部 微社区负责人
let zoneLeader = () => host + `jczl/api/zone/leader`;
// 微社区职务列表
let zoneJobList = host + "jczl/api/dictionary/zone_leader_pro_title/list";
// 网格长职务列表
let griderJobList = host + "jczl/api/dictionary/grid_user_pro_title/list";
// 业主委员会职务列表
let ownCommitteeJobList = host + "jczl/api/dictionary/pro_title_yzwyh/list";
// 物委会职务列表
let committeeJobList = host + "jczl/api/zone/property/committee/protitle";
// 删除微支部、微社区负责人接口
let delLeader = leaderId => host + `jczl/api/zone/${leaderId}/leader`;
// 获取微社区侧边查询栏
let zoneLabel = host + "jczl/api/label/zone";
// 微支部列表
let zoneList = host + "jczl/api/zone/list";

/* 日期：2019年10月11日 新接口 */
// 添加修改小区 微支部信息
let party = host + "jczl/api/party";
// 删除小区或微支部
let partyDelete = partyId => host + `jczl/api/party/${partyId}/delete`;
// 党支部侧边栏查询
let partyLabel = host + "jczl/api/label/party";
// 获取默认党支部列表
let getDefaultPartyList = zoneType =>
  host + `jczl/api/party/${zoneType}/community`;
// 获取党支部其他分支 或者 辖区党组织列表
let partyList = isSelfOrg => host + `jczl/api/party/${isSelfOrg}/zone`;
// 查询单个小区、微支部信息
let getPartyDetail = partyId => host + `jczl/api/party/${partyId}/detail`;
// 党支部轮播图第一页--社区大党委+两代表一委员
let partyOne = host + "jczl/api/party/one/auto-play";
// 党支部轮播图第一页--社区党总支
let partyTwo = host + "jczl/api/party/two/auto-play";

// 添加、修改支部对应人员类别表信息
let partyUser = host + "jczl/api/party-user";
// 添加、修改支部对应人员类别表信息
let partyUserDelete = partyUserId =>
  host + `jczl/api/party-user/${partyUserId}/delete`;

// 获取需要添加党支部人员集合
let partyList4add = host + "jczl/api/party-user/list4add";

//微支部专职委员排序
let partyUserOrder = host + "jczl/api/party-user/insertOrUpdateBatch";
/* ============= 微支部 微社区 END ============= */

/* ============= 系统字典 BEGIN ============= */
// 查询字典数据集合
let dictionaryList = type => host + `jczl/api/dictionary/${type}/list`;
/* ============= 系统字典 END ============= */
// 获取待推送列表/推送历史
let getsendList = () => {
  return host + "jczl/api/article/list";
};
// 未推送排序
let Sortsend = () => {
  return host + "jczl/api/article/sort";
};
// 保存推送
let saveSend = () => {
  return host + "jczl/api/article";
};
// 通过附件id删除附件
let delSendImg = id => {
  return host + "jczl/api/attachment/" + id + "/delete";
};
// 获取推送详情
let getSendInfo = id => host + `jczl/api/article/${id}/detail`;

// 删除某条未推送图文
let delSend = id => {
  return host + "jczl/api/article/" + id + "/delete";
};
// 推送、预览推送
let sendArtical = () => {
  return host + "jczl/api/article/send";
};
// 删除图片
let deletePic = id => {
  return host + "jczl/api/attachment/" + id + "/delete";
};
// 获取推送历史
let getHistory = host + "cmy/article/cmysendcart/getSendhistory";

/* ============= 通用接口 BEGIN ============= */
/* 添加标签分类 */
let addLabel = () => host + `jczl/api/label`;
/* 删除标签分类 */
let delLabel = delId => host + `jczl/api/label/${delId}/delete`;
// 获取活动页面的label
let getfenlei = host + `jczl/api/label/activity`;
// 留言列表
let getMessageList = host + `jczl/api/message/list`;
// 发表留言评论
let saveMessage = host + `jczl/api/message`;
// 删除留言评论
let delMessage = host + `jczl/api/message`;
// 下载附件
let downloadAttachment = host + `jczl/api/attachment/pic/download`;
// 删除附件
let delAttachment = id => host + `jczl/api/attachment/${id}/delete`;
// 导出签到报名
let downloadFile = id => host + `jczl/api/activity/${id}/export`;
/* ============= 通用接口 END ============= */
// 获取企业类型
let getQyType = host + "jczl/api/company/type";
let getQYType = host + "jczl/api/company-type";
// 查询企业属性集合
let getQyNature = host + "jczl/api/company/attr";
// 企业加盟
let addQy = host + "jczl/api/company";

// 获取企业列表
let getQyList = host + "jczl/api/company/list";

// 删除企业
let delQy = companyId => {
  return host + "jczl/api/company/" + companyId + "/delete";
};
// 获取企业标签
let getQyLabel = host + "jczl/api/label/company";

// 企业审核
let checkCompany = host + "jczl/api/company/check";
let checkCompanys = host + "jczl/api/company/check/batch";
/* ============= 企业员工 BEGIN ============= */
// 获取企业员工列表
let qyEmployeeList = id => host + `jczl/api/company/${id}/employee/list`;
// 批量审核企业员工接口
let qyEmployeeCheck = id => host + `jczl/api/company/${id}/employee/check`;
// 删除企业员工
let qyEmployeeDelete = id => host + `jczl/api/company/${id}/employee`;
// 导出获取企业员工列表
let qyEmployeeExport = id => host + `jczl/api/company/${id}/employee/export`;
/* ============= 企业员工 END ============= */
// 获取积分设置信息
let getJifen = host + "jczl/api/score/rule";

// 提交积分设置
let submitJifen = host + "jczl/api/score/rule";

// 提交党员积分百分比设置
let submitBaifenbi = host + "jczl/api/score/rule/sign";

// 查询活动参与人（报名/签到）接口集合
let getPeopleList = host + "jczl/api/activity/people/list";

// 删除微支部
let delWzb = delId => host + `jczl/api/zone/${delId}/delete`;
// 查询企业详情
let getQyDetail = companyId => host + `jczl/api/company/${companyId}/detail`;
// 获取小区中的物业等企业信息
let getZoneProperty = zoneId => host + `jczl/api/zone/${zoneId}/company`;
// 获取事件
let getZoneEvent = zoneId => host + `jczl/api/zone/${zoneId}/event`;
// 获取微支部活动
let getPartyActive = host + "jczl/api/activity/list4index";
// 获取八大类
let getService = host + "jczl/api/company/type/service";
// 查询 各社区8大类对比情况 柱状图
let getEcharts1 = host + "jczl/api/company/charts/service";
// 查询 各社区规划与实际商铺数量对比 柱状图
let getEcharts2 = host + "jczl/api/company/charts/number";
// 查询 统计商户信誉（评价排名）情况 柱状图
let getEcharts3 = host + "jczl/api/company/charts/evaluation4score";
// 获取当前街道下的社区集合
let getChildShequ = host + "jczl/api/system/community/children";
// 市教育局金点子
let listJczlbureaueducationidea = host + "jczl/jczlbureaueducationidea/list";
let ideaExport = host + "jczl/jczlbureaueducationidea/ideaExport";
let voteExport = host + "jczl/api/vote/voteExport";
// 查询企业性质数据集合
let getFeature = host + "jczl/api/company/feature";
// 获取热力图
let getHeatmap = host + "jczl/api/company/charts/heatmap";
// 获取当前社区小程序菜单配置
let getMiniSet = host + "jczl/api/miniprogram/setting";
// 改变小程序菜单显示接口
let setMiniSet = host + "jczl/api/miniprogram/setting";
// 获取积分详情列表
let getScoreList = () => host + "jczl/api/score/detail4my";
// 新增积分
let sendAddScore = () => host + "jczl/api/score";
// 删除补录积分
let delScore = id => host + `jczl/api/score/${id}/delete`;
// 查询社区公告--电视展示页
let getShowEvent = host + "jczl/event/jczlevent/list4index";
// 获取办理过程
let getProcess = host + "bpm/platform/bpm/taskOpinion/getByBusinesskey";
// 获取评价
let getEvaluation = host + "jczl/event/evaluation/getByBusinesskey";
// 电视展示页详情查询
let getShouye = type => host + `jczl/api/community/${type}/list4tv`;
// 电视展示页详情查询--图形展示
let getShouyeEc = type => host + `jczl/api/community/${type}/list4tv/chart`;
// 查询社区公告--电视展示页
let getTvGonggao = host + "jczl/api/article/list4index";
// 查询 企业评价
let getQyPingjia = host + "jczl/api/evaluation/list";
// 查询企业评价分数
let getQyScore = id => host + `jczl/api/evaluation/${id}/3/score4avg`;
// 删除企业评价
let delPingjia = host + "jczl/api/evaluation";

/** 运行监控系列 */
// 获取生活服务企业
let getCompany = countType =>
  host + `jczl/api/community/${countType}/list4communityService/chart`;
// 获取社区办理情况
let getCommunityEvent = host + "jczl/event/procedure/getEventStatistics";
// 获取社工党员办理情况
let getPeopleEvent = host + "jczl/event/procedure/getCompleteEventStatistics";
// 获取社工党员办理事件列表
let getPeopleEventList =
  host + "jczl/event/procedure/getEventListByCommunityId";

// 获取企业办理
let getCompanyEvent = host + "jczl/event/procedure/getCompanyEventStatistics";
// 事件公示
let eventIsShow = host + "jczl/event/procedure/updateEventsIsShow";
// 今日概况
let systemCount = host + "jczl/api/system/systemCount";
// 获取社区党员居民活动次数
let communityActivityNum = host + "jczl/api/community/activity/apptype/count2";
// 获取具体的活动列表
let communityActivityList =
  host + "jczl/api/activity/getActivityListByCommunityId";
// 获取每个社区党员，居民报名数，签到数
let communityEnrollNum =
  host + "jczl/api/community/activity/apptype/countDetails";
// 社区活跃度
let communityActive = host + "jczl/api/message/community/count";

// 查询所在街道及所在社区
let getAreaAndStreet = host + "jczl/api/community/area/getAreaAndStreet";
// 查询所在街道坐标列表
let getStreetPosition = host + "jczl/api/community/getStreetScopeInfo";
/** 运行监控系列 -结束 */
// 批量审核
let shenheAll = userTypeOrId =>
  host + `jczl/api/real-name/${userTypeOrId}/check`;
// 批量删除
let delAll = host + "jczl/api/community/people";
// 获取行政区域
// let getDivision = host + 'jczl/api/system/community/children'
let getDivision = type => host + `jczl/api/label/${type}/community`;
// 获取小程序码
let getQrCode = (communityId, appType) =>
  host + `jczl/api/miniprogram/community/${communityId}/${appType}/qrcode`;
// 获取社区事件
let getSqEvent = host + "jczl/event/procedure/getDyCommunityEventList";
// let getSqEvent = host + "jczl/event/procedure/getCommunityEventList";
// 导出社区事件
let downSqsj = (currentCommunityId, uId, votegree) =>
  host +
  `jczl/event/procedure/${currentCommunityId}/${uId}/${votegree}/exportCommunityEventList`;
// 导出企业
let downQy = host + "jczl/api/company/export";
// 导出居民
let downCitizen = host + "jczl/api/resident/export";
// 导出居民模板
let downCitizenModel = host + "jczl/api/resident/template/export";
// 添加、修改电话本信息
let changePhone = host + "jczl/api/phonebook";
// 查询电话本信息列表
let getPhoneList = host + "jczl/api/phonebook/list";
// 删除电话
let delPhone = phoneBookId => host + `jczl/api/phonebook/${phoneBookId}/delete`;

// 获取事件详情
let getSqEventDetail = host + "jczl/event/procedure/getDetails";
// 获取公众号二维码
let erweima = host + "jczl/api/wechat/gzh";
// 获取社区自行解决率统计图
let getEventDealPer = host + "jczl/event/jczlevent/process4self";
// 导出社区自行解决率
let exportEventDealPer = host + "jczl/event/jczlevent/process4self/export";
// 是否能下载活动二维码
let canDownActCode = (activityId, type) =>
  host + `jczl/api/activity/${activityId}/${type}/exists`;
// 下载活动二维码
let downActCode = (activityId, type) =>
  host + `jczl/api/activity/${activityId}/${type}/download4pic`;

/**
 * 停车管理模块
 * edit by wxf
 * 2019/07/22
 */
let getParklingList = host + "jczl/api/parking/list";
let getParkingOptionList = host + "jczl/api/parkingoption/list";
let saveParkingOption = host + "jczl/api/parkingoption";
let deleteParkingOption = parkingOptionId =>
  host + `jczl/api/parkingoption/${parkingOptionId}/delete`;
let deleteParkingInfo = parkingId =>
  host + `jczl/api/parking/${parkingId}/delete`;
let exportData = host + "jczl/api/parking/export";

// 获取投票列表
let getVoteList = host + "jczl/api/vote/list";
// 删除投票
let deleteVote = id => host + `jczl/api/vote/${id}/delete`;
// 发布投票
let newVote = host + "jczl/api/vote";
// 分享二维码
let voteCode = host + "jczl/api/vote/community/qrcode3";
// 分享图片
let inviteCode = host + "jczl/api/vote/createVoteGraphics3";
// 投票详情
let voteDetail = voteId => host + `jczl/api/vote/${voteId}/detail`;
// 选项详情
let optionDetail = voteId => host + `jczl/api/vote/${voteId}/option`;
// 投票人信息
let selPerson = optionId => host + `jczl/api/vote/option/${optionId}/user`;
// 选项详情
let selDetail = host + "jczl/api/context";
// 查询全国小区
let getHouse = host + "jczl/api/housing/list";
// 查询实名认证配置信息
let getFiledConfig = host + "jczl/api/realname-field-config/list";
// 配置实名认证信息
let fieldConfig = host + "jczl/api/realname-field-config";
// 删除配置项
let delConfig = host + "jczl/api/realname-field-config/delete";
// 获取实名认证配置详情
let getAuthDetail = host + "jczl/api/realnameField/list";
// 保存个人信息实名认证配置项
let setAuthDetail = host + "jczl/api/realnameField/batchInsertOrUpdate";

/** 积分设置相关 */
// 获取积分规则
let getJfRule = appType => host + `jczl/api/score/${appType}/rule`;
// 修改积分规则
let setJfRule = appType => host + `jczl/api/score/${appType}/rule`;
// 修改党员活动签到积分比例
let setAuthJf = host + "jczl/api/score/rule/sign";

/** end 积分设置相关 */
// 获取民生通首页功能模块配置
let getMstSetting = host + "jczl/api/miniprogram/module/settingList";
// 获取民生通首页可配置项列表
let getSettingList = host + "jczl/api/moduleSetting/list";
// 获取功能模块详情
let getModelDetail = host + "jczl/api/miniprogram/module/detail";
// 获取可关联模块
let getConnectModel = host + `jczl/api/module/list`;
let getModelIcon = host + "jczl/api/moduleIcon/list";
// 上传模块图标
let addIcon = host + "jczl/api/moduleIcon";
// 设置模块样式
let setStyle = host + "jczl/api/moduleSetting";
// 配置列表排序
let sortList = host + "jczl/api/miniprogram/module/sort";
// 配置模块信息
let setModule = host + "jczl/api/miniprogram/module/updateModuleSettingById";
// 获取公告列表
let getNoticeList = host + "jczl/api/notice/list";
// 公告排序
let noticeSort = host + "jczl/api/notice/sort";
// 取消公示
let cancelNotice = host + "jczl/api/notice/status";
// 删除公告
let delNotice = noticeId => host + `jczl/api/notice/${noticeId}/delete`;
// 获取公告链接
let geiNoticeLink = host + "jczl/api/notice/link";
// 查询模板
let getTemp = host + "jczl/api/notice/release";
// 获取公告详情
let getNoticeDetail = noticeId => host + `jczl/api/notice/${noticeId}/detail`;
// 获取公告类别
let getNoticeTag = host + "jczl/api/notice/notice-type?containsSystemNotice=1";
// 发布公告
let newNotice = host + "jczl/api/notice";
// 退出登录
const logOut = host + "jczl/api/logout";
// 组织相关 ======================================
// 添加、修改社区组织信息
const changeOrg = host + "jczl/api/org";
// 查询社区组织信息列表(包含人员、活动数量积分及排名)
const getOrganize = host + "jczl/api/org/detailList";
//查询社区组织
const getOrgList = host + "jczl/api/org/list";
// 查询单个组织详情（包含成员数量，活跃排名）
const getOrgDetail = host + "jczl/api/org/orgDetail";
// 获取组织的成员列表(包含成员积分记录/排名)
const getOrgMember = host + "jczl/api/org/orgUserList";
// 查询社区组织对应图片以及活动相册图片
const getOrgAlbum = host + "jczl/api/org2pic/listOrg2picAndActivity2pic";
// 添加、修改社区组织对应图片信息
const saveOrgPic = host + "jczl/api/org2pic";
// 删除社区组织对应图片信息
const delOrgPic = id => host + `jczl/api/org2pic/${id}/delete`;
// 删除社区组织信息
const delOrg = id => host + `jczl/api/org/${id}/delete`;
// 根据组织ID查询组织的活动列表接口
const getOrgActive = host + "jczl/api/activity/listByOrgId";
// 获取可用的活动主办方集合
const getZhuban = host + "jczl/api/activity/organizer";
// 获取系统所有已实名用户
const getAllRealName = host + "jczl/api/org/user4choose";
// 批量添加社区组织人员
const saveOrgMember = host + "jczl/api/org/user";
// 删除社区组织对应用户信息
const delOrgMember = host + "jczl/api/org/deleteOrgUser";
// 组织待审核人员审核接口
const orgShenhe = host + "jczl/api/org/checkOrg2User";
// 获取当前系统下各社区组织数量
const getOrgNumByCom = host + "jczl/api/org/communityOrgCount";
// 组织相关 ======================================end

// 获取转派人员列表
const getWorker = host + "jczl/api/process/company/worker";
// 社区事件办理
const completeMobile = host + "bpm/platform/bpm/task/complete";
// 事件办理传附件
const completeFile = host + "jczl/event/supply/save";
// 事件直接办结
const endMobile = host + "bpm/platform/bpm/task/endProcess";
// 发布抢单
const qiangdan = host + "jczl/event/jczleventorder/save";
// 转派至企业
const eventToCompany = host + "jczl/event/jczlevent/turn2company";
// 转派
const eventRedeploy = host + "jczl/event/jczleventorder2user/save";
// 事件详情页导出事件工单
const exportDetail = id => host + `jczl/event/procedure/${id}/export4detail`;
//查看已读未读
const getReadPeople = taskId => host + `jczl/event/procedure/${taskId}/user`;

// 系统公告列表
const sysNoticeList = host + "jczl/api/system-notice/list";
// 全部已读
const readAll = host + "jczl/api/system-notice/readall";
// 系统公告详情
const sysNoticeDetail = systemNoticeId =>
  host + `jczl/api/system-notice/${systemNoticeId}/detail`;
// 居民议事厅列表
const assemblyList = host + "jczl/api/meeting/list";
// 删除居民议事厅
const delAss = meetingId => host + `jczl/api/meeting/${meetingId}/delete`;
// 居民议事厅详情
const assDetail = meetingId => host + `jczl/api/meeting/${meetingId}/detail`;
// 居民议事厅发布
const assembly = host + "jczl/api/meeting";

// 积分兑换==============================================start
// 获取管理员查看的商品列表
const getGoodsList = host + "jczl/api/goods/admin/list";
// 查询积分兑换页面标签
const getGoodsLabel = host + "jczl/api/label/goods";
// 添加修改商品信息
const submitGood = host + "jczl/api/goods/addOrUpdate";
// 根据商品ID获取商品详情
const getGoodDetail = id => host + `jczl/api/goods/${id}/information`;
// 重置商品二维码
const getGoodQrcode = id => host + `jczl/api/goods/${id}/qrcode`;
// 获取兑换统计人员集合
const getExchangePeople = id => host + `jczl/api/goods/${id}/people4exchange`;
// 获取当前商品 未核销/未兑换 人员集合
const getGoodPeople = (id, type) =>
  host + `jczl/api/goods/${id}/${type}/people`;
// 积分兑换--核销接口
const goodEchange = (id, isreturn) =>
  host + `jczl/api/goods/${id}/${isreturn}/consume4batch`;
// 积分兑换--批量补录
const goodBulu = id => host + `jczl/api/goods/${id}/patch4batch`;
// GET /api/goods/{goodsId}/download4pic
// 下载商品二维码图片--前端需用window.open调用
const downGoodQrcode = id => host + `jczl/api/goods/${id}/download4pic`;
// 导出兑换统计人员集合--前端需用window.open调用
const exportGoodPeople = id =>
  host + `jczl/api/goods/${id}/people4exchange/export`;
// 删除或撤销商品
const delGood = id => host + `jczl/api/goods/${id}/delete`;
// 检查商品二维码图片是否存在，如果不存在则会抛出异常信息
const checkDownload = id => host + `jczl/api/goods/${id}/qrcode/exists`;
// 根据类型获取当前社区企业所属属性
const getQiyeType = host + `jczl/api/company-type`;
// 查询企业业务类型表信息列表
const getCompayType = host + "jczl/api/company-type/list";
// 查询行业列表
const getIndustryCategory = host + "jczl/api/dictionary/company_trade/list";
// 分局列表
const getDepList = host + "jczl/api/dept/list";
// 新增企业消杀记录
const addSterilzatioin = host + "jczl/api/company-disinfect?";
// 查询消杀记录
const getSterilzatioin = host + "jczl/api/company-disinfect/list";
// 添加防疫物资
const addSupplies = host + "jczl/api/company-supplies";
// 获取防疫物资
const getSupplies = host + "jczl/api/company-supplies/list";
// 查询单个企业业务类型表信息
const getTypeDetail = id => host + `jczl/api/company-type/${id}/detail`;
// 查询企业图标配置表信息列表
const getTypeIcon = host + "jczl/api/company-icon/list";
// 添加、修改企业图标配置表信息
const addCompanyIcon = host + "jczl/api/company-icon";
// 排序接口
const companyTypeSort = host + "jczl/api/company-type/sort";
// 删除企业业务类型以及子模块信息
const delCompanyType = id => host + `jczl/api/company-type/${id}/delete`;
// 通过服务八大类链接添加企业业务类型
const addService = id => host + `jczl/api/company-type/${id}/link`;
// 活动页面--获取当前街道下的社区集合，如果当前登录的是社区级别，返回当前社区，如果是街道级别返回当前街道以及街道所属社区
const getActiveLabel = host + "jczl/api/system/community/children/activity";
// 获取居民议事厅参会人列表
const getPerson = host + "jczl/api/meeting/user4choose";
// 广告相关 =====================================
// 添加、修改广告信息
const addAd = host + "jczl/api/ad";
// 党员先锋 相关=================================
// 查询个人事迹信息列表
const getVanguard = host + "jczl/api/deeds/list";
// 获取当前可以添加个人事迹的人员列表
const getVanguardSelect = chooseTime =>
  host + `jczl/api/deeds/user/${chooseTime}/list4add`;
// 批量添加、修改个人事迹信息
const submitVanguard = (chooseTime, status) =>
  host + `jczl/api/deeds/${chooseTime}/${status}/batch`;
// 查询单个个人事迹信息
const getVanguardDetail = deedsId => host + `jczl/api/deeds/${deedsId}/detail`;
// 删除个人事迹信息/根据评选日期删除
const delVanguard = host + "jczl/api/deeds/delete?";
// 查询广告可以链接的企业列表集合
const getAddCompany = host + "jczl/api/ad/company4link";
// 查询广告信息列表
const getAdvert = host + "jczl/api/ad/list";
// 查询单个广告信息
const getAdDetail = adId => host + `jczl/api/ad/${adId}/detail`;
// 排序接口
const adSort = host + "jczl/api/ad/sort";
// 修改广告状态（撤回到草稿/取消公示） 接口
const changeAdStatus = host + "jczl/api/ad/status";
// 删除广告信息
const delAdvert = adId => host + `jczl/api/ad/${adId}/delete`;
// 查询已经发布过（排除草稿）的广告集合
const getAllAdvert = host + "jczl/api/ad/release";
//新居民详情
const residentDetail = host + "jczl/api/resident/detail";
//认证信息
const getAuth = userType => host + `jczl/api/real-name/${userType}/detail`;
//居民详情编辑
const applyRealname = userType =>
  host + `jczl/api/real-name/${userType}/data-value`;
//获取活动默认数据
const getActPre = host + "jczl/api/activity/default4add";
//居民详情时长列表
const timelengthList = host + "jczl/api/time-length/list";
//添加、修改时长
const addTimeLength = host + "jczl/api/time-length";
//删除时长
const delTimeLength = id => host + `jczl/api/time-length/${id}/delete`;
//丛台token
const getCTToken = host + "jczl/api/system/token4area";
// 获取添加预约办理服务项目默认值
const getAppiontmentDefalut = host + "jczl/api/appointment/default4add";
// 添加、修改预约办理服务项目信息
const submitAppointment = host + "jczl/api/appointment";
// 查询预约办理服务项目信息列表--PC接口
const getAppointmentList = host + "jczl/api/appointment/list";
// 批量修改预约办理服务项目状态
const changeAppointmentStatus = host + "jczl/api/appointment/status";
// 批量删除预约办理服务项目信息
const delAppointment = host + "jczl/api/appointment/delete";
// 查询单个预约办理服务项目信息
const getAppointmentDetail = id => host + `jczl/api/appointment/${id}/detail`;
const getAppointmentDatedetail = id =>
  host + `jczl/api/appointment/${id}/datedetail`;
// 单个预约办理服务项目保存特殊日期
const tmentDateSave = host + `jczl/appointmentDate/appointmentDate/save`;
const getTmentDate = host + `jczl/appointmentDate/appointmentDate/list`;
const tmentDateDel = host + `jczl/appointmentDate/appointmentDate/del`;
const tmentTimeSave = host + `jczl/api/appointment/handDatedetailTime`;
// 查询用户预约办理服务项目列表信息列表
const getAppointmentUser = host + "jczl/api/appointment-user/list";
// 通过 事项名称ID 查询预约时间
const getAppointmentTime = host + "jczl/api/appointment/time4query";
// 办理/取消 用户预约的服务项目
const changeUserAppointment = host + "jczl/api/appointment-user/deal";
// 查询 用户预约办理服务项目 办理信息
const getAppointmentBanliDetail = id =>
  host + `jczl/api/appointment-user/${id}/detail4deal`;
// 导出用户预约办理服务项目列表--前端需用window.open调用
const uploadAppointmentUser = host + "jczl/api/appointment-user/export";
//获取假token
const getMockToken = host + "uc/api/user/login?logintype=6";
//获取电视大屏模块
const getModule = host + "base/base/Base_Datas/GetCodeByType.ht";
// 黑名单查询
const jczlAppointmentBlacklist =
  host + "jczl/portal/jczlAppointmentBlacklist/list";
const saveblacklist = host + "jczl/portal/jczlAppointmentBlacklist/save";
const delblacklist = host + "jczl/portal/jczlAppointmentBlacklist/del";
const getappointmentBlacklist =
  host + "jczl/api/deptManager/appointmentBlacklist";

/* ============= 共享 BEGIN ============= */
// 获取提供方 需求方
const share_provider = type => host + `jczl/api/resource/${type}/provider`;
// 查询单个共享资源/需求服务信息
const share_getDetail = resourceId =>
  host + `jczl/api/resource/${resourceId}/detail`;
// 查询共享资源/需求服务信息列表
const share_list = host + "jczl/api/resource/list";
// 批量删除共享资源/需求服务信息
const share_delete = host + "jczl/api/resource/delete";
// 添加、修改共享资源/需求服务信息
const share_resource = host + "jczl/api/resource";
/* ============= 共享 END ============= */

// 公告文件下载
const dowloadFile = host + "jczl/api/attachment/download";

//获取可转派社区
const zhuanShequ = host + "jczl/api/community/borther/children";
//转给社区
const turnShequ = host + "jczl/event/jczlevent/turn2community";

/**社区防疫相关 */
//获取行政区域
const getArea = host + "upms/upms/area/listByParentId.ht?";
//获取城市名
const getCity = host + "upms/upms/area/get.ht?";
//提交相关接口
//提交人员信息
const submitPeople = host + "jczl/api/epidemic/people";
//查看防疫人员信息详情
const getPeopleFangyiDetail = epidemicPeopleId =>
  host + `jczl/api/epidemic/people/${epidemicPeopleId}/detail`;

//列表接口
// 提醒用户完善上报防疫信息
const epidemicNotice = host + "jczl/api/epidemic/remind";
//查询社区防疫人员信息列表
const getFangyiList = host + "jczl/api/epidemic/people/list";

// 实名认证
let realName = host + `jczl/api/epidemic/getPeopleAndInfoList`;
let realUpData = host + "jczl/api/epidemic/getPeopleAndInfoListExport";
//删除社区防疫人员信息列表
const delFangyiList = host + "jczl/api/epidemic/people/delete";
//导出社区防疫人员信息列表
const exportFangyiList = host + "jczl/api/epidemic/people/export";
//审核居民信息
const checkPeople = host + "jczl/api/epidemic/people/check";
//下载居民登记卡
const exportPeopleCard = host + "jczl/api/epidemic/people/register-card/export";

//详情接口
//查询社区防疫人员详情
const getFangyiDetail = epidemicPeopleId =>
  host + `jczl/api/epidemic/people/${epidemicPeopleId}/detail`;
//查询健康信息列表
const getHealthyList = host + "jczl/api/epidemic/people/healthy/list";
//提交人员健康信息列表
const submitPeopleHealthy = host + "jczl/api/epidemic/people/healthy";
//删除人员健康信息
const delPeopleHealthy = host + "jczl/api/epidemic/people/healthy/delete";
// 查询社区防疫字段配置信息列表
const getEpidemicSetting = host + "jczl/api/epidemic/field-config";
//导出健康信息列表
const exportHealthList = host + "jczl/api/epidemic/people/healthy/list/export";

//配置接口
// 控制社区防疫字段配置信息显示/隐藏
const changeEpidemicSetting = host + "jczl/api/epidemic/field-config/show";
// 获取/提交社区防疫温馨提示
const getFangyiNotice = host + "jczl/api/epidemic/welcome-message";
// 查询社区疫情登记卡配置信息列表
const getFangyiPeopleCardInfo = host + "jczl/api/register-card/list";
//添加、修改社区疫情登记卡配置信息
const editFangyiHotline = host + "jczl/api/register-card";
// 导入防疫信息
const importFangyi = host + "jczl/api/company/import";
// 查询重复数据
const fangyiChachong = host + "jczl/api/epidemic/people/repeat/list";
// 合并数据
const chachongMerge = host + "jczl/api/return-people/merge";
//查询返回人员情况信息列表
const peopleLibraryList = host + "jczl/api/return-people/list";
//导出名单库
const exportLibrary = host + "jczl/api/return-people/export";
// 名单库 上传文件，批量导入数据
const importLibrary = host + "jczl/api/return-people/import";
// 批量删除返回人员情况信息
const delLibrary = host + "jczl/api/return-people/delete";
// 查询单个返回人员情况信息
const getLibraryDetail = id => host + `jczl/api/return-people/${id}/detail`;
// 添加、修改返回人员情况信息,新增的时候如果有重复数据（通过社区ID和身份证号码判断）就执行修改
const changeLibrary = host + "jczl/api/return-people";
// 查询居民社区防疫走动记录信息列表
const getWalkRecord = host + "jczl/api/walk-record/list";
// 出居民社区防疫走动记录信息列表
const exportWalkReport = host + "jczl/api/walk-record/export";
// 下载出入登记二维码--window.open调用
const walkRecordDownload = host + "jczl/api/walk-record/qrcode/download";
/**社区防疫结束 */

// 生成社区对应小程序二维码
const downQrcode = communityId =>
  host + `jczl/api/miniprogram/create/${communityId}/qrcode`;
// 查询系统公告信息列表最新一条记录--免登录
const getSysNotice = host + "jczl/api/system-notice/newest";
// 查询单个系统公告信息--免登录
const getSysNoticeDetail = id =>
  host + `jczl/api/system-notice/newest/${id}/detail`;
//获取级联行政区域
const getCommunityCascade = host + "jczl/api/community/cascade";

/**口罩预约 */
//获取可预约企业
const getYuyueCompany = host + "jczl/api/mask-config/company4select";
//添加/修改预约配置
const setYuyueConfig = host + "jczl/api/mask-config";
//查询口罩预约设置列表
const getYuyueSettingList = host + "jczl/api/mask-config/list";
//查询单个预约设置详情
const getYuyueConfig = id => host + `jczl/api/mask-config/${id}/detail`;
//口罩预约记录
const getYuyueList = host + "jczl/api/mask-appointment/list";
//获取预约轮次
const getRound = host + "jczl/api/mask-appointment/round";
//查询登记人信息
const searchPeopleInfo = host + "jczl/api/epidemic/people/detail";
//添加预约记录
const addYuyueRecord = host + "jczl/api/mask-appointment/buy";
//导出预约记录
const exportYuyueRecord = host + "jczl/api/mask-appointment/export";
//删除记录
const delRecordList = host + "jczl/api/mask-appointment/delete";
//审核口罩记录接口
const checkRecordPeople = host + "jczl/api/mask-appointment/check";
/**口罩预约结束 */

/**社区防疫统计大屏**/

//获取省份简称
const getProviceShort = host + "jczl/api/system/sn";
//社区防疫人员统计
const getEpidemicUserCount = host + "jczl/api/epidemic-count/user";
// 获取各社区人员摸排情况
const getEpidemicUserList = host + "jczl/api/epidemic-count/user/list";
// 获取发热人员情况统计
const getEpidemicFeverUser = host + "jczl/api/epidemic-count/feverUser";
//回邯方式
const getEpidemicHBMobilityTrends =
  host + "jczl/api/epidemic-count/HBMobilityTrends";
// 获取社区人员概况
const getEpidemicUserInfo = host + "jczl/api/epidemic-count/userInfo";
//人员流动趋势统计
const getEpidemicTrendsStatistics =
  host + "jczl/api/epidemic-count/mobilityTrends";
// 健康信息统计
const getEpidemicHealthStatistics =
  host + "jczl/api/epidemic-count/healthyStatistics";
// 获取小区出入情况统计
const getEpidemicCommunityWalk = host + "jczl/api/epidemic-count/communityWalk";
// 获取门店出入情况统计
const getEpidemicCompanyWalk = host + "jczl/api/epidemic-count/companyWalk";
// 获取小区人员出入情况
const getEpidemicWalk = host + "jczl/api/epidemic-count/walk";
// 获取归来人员属地
const getPosition = host + "jczl/api/epidemic-count/userMap";
/**社区防疫统计大屏结束**/
// 获取部门列表
const getDeptList = host + "jczl/api/dictionary/dept_type/list";
//
const getDeptTableList = host + "jczl/api/dept/list";

const addDept = host + "jczl/api/dept";

const delDept = host + "jczl/api/dept/delete";

const getManagerList = host + "jczl/api/deptManager/list";
const addManager = host + "jczl/api/deptManager";
const getUserList = host + "jczl/api/deptManager/listDeptUser";
const delManager = host + "jczl/api/deptManager/delete";
const syncCommonTpyeDept = host + "jczl/api/miniprogram/syncCommonTpyeDept";

const people4list = host + "jczl/api/epidemic/company/people4list";
const people4export = host + "jczl/api/epidemic/company/people4export";

// 诉求须知
const demandNotice = host + "jczl/api/demandNotice";
const demandNoticeList = host + "jczl/api/demandNotice/list";

//网格

// 查询网格管理信息列表
const gridList = () => host + "jczl/api/grid/list";
// 增加修改网格信息
const addGrid = () => host + "jczl/api/grid";
// 获取网格级别列表
const gridLevel = () => host + "jczl/api/grid/level";
// 查询网格页面标签
const gridLabel = () => host + "jczl/api/label/grid";
// 批量删除网格管理信息
const delGrid = ids => host + `jczl/api/grid/delete?idList=${ids}`;
// 查询单个网格管理信息
const getGridDetail = id => host + `jczl/api/grid/${id}/detail`;
// 查询网格长信息信息列表
const getGridUserList = () => host + "jczl/api/grid/user/list";
//添加、修改网格长信息信息
const addGridUser = () => host + "jczl/api/grid/user";
//批量删除网格长信息信息
const delGridUser = ids => host + `jczl/api/grid/user/delete?idList=${ids}`;
//查询当前社区下网格数据集合，级联格式
const gridCascade = host + "jczl/api/grid/cascade";

// 业主委员会

//通过小区ID查询已经发布过（排除草稿）的社区公告集合
const ownerCommitteeList = zoneId =>
  host + `jczl/api/owner-committee/zone/${zoneId}/notice/release`;
//添加社区公告信息
const addOwnCommitteeNotice = zoneId =>
  host + `jczl/api/owner-committee/zone/${zoneId}/notice`;
//批量删除小区公告
const deleteOwnCommitteeNOtice = zoneId =>
  host + `jczl/api/owner-committee/zone/${zoneId}/notice/delete`;
//获取可以添加到当前业委会人员集合(从当前社区居民下筛选)
const ownCommiteeList = host + "jczl/api/owner-committee/zone/user/list4add";
//添加、修改业主委员会信息
const addOwnCommittee = host + "jczl/api/owner-committee";
//查询业主委员会信息列表
const getOwnCommiteeList = host + "jczl/api/owner-committee/list";
//批量删除业主委员会信息
const delOwnCommittee = id =>
  host + `jczl/api/owner-committee/delete?idList=${id}`;

// 社会保险记录
const ssList = host + "jczl/api/social-insurance/list";
const ssExport = host + "jczl/api/social-insurance/export";
const ssImport = host + "jczl/api/social-insurance/import";
const ssDetail = socialInsuranceId =>
  host + `jczl/api/social-insurance/${socialInsuranceId}/detail`;
const ssDelete = id => host + `jczl/api/social-insurance/delete?idList=${id}`;
//人工认证
const artificialVerify = socialInsuranceId =>
  host + `jczl/api/social-insurance/${socialInsuranceId}/artificial-verify`;
//死亡注销
const deathConfirm = socialInsuranceId =>
  host + `jczl/api/social-insurance/${socialInsuranceId}/death-confirm`;
//死亡恢复
const deathRecover = socialInsuranceId =>
  host + `jczl/api/social-insurance/${socialInsuranceId}/getRight`;
// 抵押登记费用
const taxInfoList = host + "jczl/api/estate-order/pay/list";
const taxInfoDetail = host + "jczl/api/estate-order/payInfo";
const updateInvoice = socialInsuranceId =>
  host + `jczl/api/estate-order/updateInvoice?orderNO=${socialInsuranceId}`;

let cancellation = host + "/thirditf/api/eticket/2.0/cancellation";
let invoice = host + "/thirditf/api/eticket/2.0/invoice";
if (
  window.location.host.indexOf("ceshi.shequyun.cn") >= 0 ||
  window.location.host.indexOf("localhost") >= 0
) {
  invoice = "https://ceshi.shequyun.cn/thirditf/api/eticket/2.0/invoice";
  cancellation =
    "https://ceshi.shequyun.cn/thirditf/api/eticket/2.0/cancellation";
} else if (window.location.host.indexOf("py.shequyun.cn") >= 0) {
  invoice = "https://py.shequyun.cn/thirditf/api/eticket/2.0/invoice";
  cancellation = "https://py.shequyun.cn/thirditf/api/eticket/2.0/cancellation";
}
const getuser3list = host + "jczl/api/estate-order/user3/list";
const saveHui = host + "thirditf/api/eticket/2.0/remitFind";
const updateInvoiceList = host + "jczl/api/estate-order/updateInvoiceList";
const regfeeExport = host + "jczl/api/estate-order/regfee/export";
//人脸认证记录
const faceVerifyList = host + "jczl/api/face-verify/list";
//承诺书、查档函
const PromiseList = host + "jczl/deal/estateDealPromise/list";
const PromiseReceive = host + "jczl/deal/estateDealPromise/receive";
const download = dType =>
  host + `jczl/deal/estateDealPromiseTwo/downloadTwo/${dType}`;
const download1 = dType =>
  host + `jczl/deal/estateDealPromise/download/${dType}`;
const saveType = host + "jczl/deal/estateDealPromise/3.0/3.1/save";
const updateType = host + "jczl/deal/estateDealPromiseTwo/update";
const PromiseFileList2 = host + "jczl/deal/estateDealPromiseFile/list";
const PromiseFileList = str => host + "jczl/api/attachment/list" + str;
const PromiseFileList1 = host + "jczl/deal/estateDealPromiseFile/list";
// 信息采集
const dataCollectionList = host + "jczl/api/estate-collection/list";
const dataCollectionExport = host + "jczl/api/estate-collection/export";
const dataColectDetail = estateCollectionId =>
  host + `jczl/api/estate-collection/${estateCollectionId}/detail`;
const batchCheckLandTransfer = host + "jczl/api/estate-collection/check-batch";
const deleteCollectionBatch = host + "jczl/api/estate-collection/delete";
// 高龄津贴申请
const applyList = host + "jczl/api/advanced-age-info/list";
const applyDelete = host + "jczl/api/advanced-age-info/delete";
const handleApply = host + "jczl/api/advanced-age-info";
const updateAuditStatus = host + "jczl/api/advanced-age-info/updateAuditStatus";
const addApplyInfo = host + "jczl/api/advanced-age-info";
const applyExport = host + "jczl/api/advanced-age-info/export";
const importExcel = host + "jczl/api/advanced-age-info/import";
// 查询不动产快递信息列表
const mailList = host + "jczl/api/estate-express/listAll";
const mailListDetail = orderNO =>
  host + `jczl/api/estate-express/expressInfo?orderNO=${orderNO}`;
const updataMailInfo = host + `jczl/api/estate-express`;
const mailListExport = host + "jczl/api/estate-express/regfee/export";
//契税信息
const taxQuery = host + "jczl/api/estate-order/taxInfo";
//出生证明查询
const birthCert = host + "thirditf/api/estate/getBirthInfo";
//婚姻登记信息查询
const marriageRegister = host + "thirditf/api/estate/getMarriageRegistration";
//人口信息核验查询接口
const rkMessVerification =
  host + "thirditf/api/dataShare/getRkMessVerification";
//死亡医学证明查询接口
const swyxzmInfo = host + "thirditf/api/dataShare/getSwyxzmInfo";
//民政部_民办非企业单位登记证书查询接口
const mzbJjhfr = host + "thirditf/api/estate/getMzbJjhfr";
//工商总局_企业基本信息查询接口
const gszjqyjbxxcx = host + "thirditf/api/estate/getgszjqyjbxxcx";
//工商总局_企业基本信息验证接口
const gszjqyjbxxyz = host + "thirditf/api/estate/getgszjqyjbxxyz";
// 编办_事业单位及党群机关
const bbSydwdqjg = host + "thirditf/api/dataShare/bbSydwdqjg";
// 高院的判决信息
const qyjjjfpjxx = host + "jczl/api/qyjjjfpjxx/list";

//疫情期间人员排查记录

//添加、修改疫情期间人员排查记录信息
const addPersonInspection = host + "jczl/api/person-inspection";
//批量删除疫情期间人员排查记录信息
const deletePersonInspection = host + "jczl/api/person-inspection/delete";
//导出重点人员排查信息
const exportPersonInspection = host + "jczl/api/person-inspection/export";
//上传文件，批量导入数据
const importPersonInspection = host + "jczl/api/person-inspection/import";
//查询疫情期间人员排查记录信息列表
const getPersonInspectionList = host + "jczl/api/person-inspection/list";
//查询单个疫情期间人员排查记录信息
const getPersonInspectionById = personInspectionId =>
  host + `jczl/api/person-inspection/${personInspectionId}/detail`;

//查询电子场所码进出记录
const getWalkRecordList = host + "jczl/api/walk-record/company/list";
//导出电子场所码进出记录
const exportWalkRecordList = host + "jczl/api/walk-record/company/export";

// 首席服务员系列

// 导出首席服务员
const exportChiefWaiterExcel = host + "jczl/api/waiter/user/regfee/export";
// 根据类型 获取字典
const getDicList = type => host + `jczl/api/dictionary/${type}/list`;
// 获取首席服务员列表
const postChiefWaiterList = host + "jczl/api/waiter/user/list";
// 新增，编辑，审核，首席服务员
const postChiefWaiter = host + "jczl/api/waiter/user";
// 批量审核首席服务员
const postBatchAuditWaiter = host + "jczl/api/waiter/user/updateIsCheck";
// 获取首席服务员每月自评---通过unionid 查询
const postChiefWaiterEvaluateList = host + "jczl/api/waiter/evaluate/list";
// 获取首席服务员工作纪实---通过unionid 查询
const postChiefWaiterDocumentaryWork = host + "jczl/api/waiter/record/list";
// 获取首席服务员工作纪实详情
const getChiefWaiterDocumentaryWorkDetail = waiterRecordId =>
  host + `jczl/api/waiter/record/${waiterRecordId}/detail`;
// 删除工作记实或者工作专班
const deleteWorkRecordOrWordSpecialClasses =
  host + "jczl/api/waiter/record/delete";
// 工作专班回复
const postReplyWorkSpecialClasses = host + "jczl/api/waiter/record";
// 获取首席服务员详情
const getChiefWaiterDetail = waiterUserId =>
  host + `jczl/api/waiter/user/${waiterUserId}/detail`;
// 批量删除首席服务员 --- 参数为 idList:[]
const deleteChiefWaiter = host + "jczl/api/waiter/user/delete";
// 通过姓名查询小程序登录过的首席服务员
const postChiefWaiterUserList = host + "jczl/api/waiter/user/userlist";
// 获取记实统计列表及详细信息
const postRecordStatistic = host + "jczl/api/waiter/user/rcordStatistics";
// 获取记实统计问题列表及详细信息
const postQuestionList = host + "jczl/api/waiter/user/rcordStatistics2";
// 获取自评统计列表及详细信息
const postEvaluateStatistic = host + "jczl/api/waiter/user/selfStatistics";
// 导出记实统计
const exportRecordStatisticsExcel =
  host + "jczl/api/waiter/user/record-statistics/export";
// 导出问题统计
const exportQuestionListExcel =
  host + "jczl/api/waiter/user/record-statistics/export1";
// 导出自评统计
const exportSelfStatisticsExcel =
  host + "jczl/api/waiter/user/self-statistics/export";

//东乡大屏
//热点
const dx_rdfx =
  host +
  "urlrewrite/223.82.47.235:12501/bigdata/bigData/BigdataHomepage/getMssqEventTypeSource";
//专业网格
const dx_zywg =
  host +
  "urlrewrite/223.82.47.235:12501/bigdata/bigData/BigdataHomepage/getHomePageEvent";
// 事件受理
const dx_sjsl =
  host +
  "urlrewrite/223.82.47.235:12501/bigdata/bigData/BigdataHomepage/getHomePageZHZFAcceptance";
// 部门受理
const dx_bmsl =
  host +
  "urlrewrite/223.82.47.235:12501/bigdata/bigData/BigdataHomepage/getMssqAcceptanceFinish";
// 实时动态
const dx_ssdt =
  host +
  "urlrewrite/223.82.47.235:12501/event/whistle/whistleevent/getEventByDx";

// dl
const dx_dl = host + "urlrewrite/223.82.47.235:12501/upms/upms/login";

// 东乡大屏
const dx_jjfx =
  host +
  "urlrewrite/223.82.47.235:12501/bigdata/bigData/HandanData/getCTQForty.ht";
const dx_jjfxty =
  host +
  "urlrewrite/223.82.47.235:12501/bigdata/bigData/HandanData/getCTQFortytechnology.ht";

//半壁店大屏
const bbd_dp = host + "event/whistle/whistleevent/getEventByBbd";

//新生儿
const newborn = host + "jczl/api/new-baby/list";
const downloadNewborn = host + "jczl/api/new-baby/pdf/download";

// 新生入学接口
const selectAllCommitStudent =
  host + "jczl/api/new-student/admin/selectAllCommitStudent/";
const selectSignUpCommitInfo =
  host + "jczl/api/new-student/admin/selectSignUpCommitInfo";
const selectSchoolInfo = host + "jczl/api/new-student/admin/selectSchoolInfo";
const insertNewStudentSchool =
  host + "jczl/api/new-student/admin/insertNewStudentSchool";
const getselectAllInfo = host + "jczl/api/new-student/selectAllInfo/";
// const getadminVerify = host + "jczl/api/new-student/admin/adminVerify"
const getadminVerify = host + "jczl/api/new-student/admin/adminVerifyOnce/";
const getadminVerifyList = host + "jczl/api/new-student/admin/adminVerifyList";
const getselectVerifyInfo = host + "jczl/api/new-student/selectVerifyInfo/";
const selectVerifyImage = host + "jczl/api/new-student/selectVerifyImage/";
const deleteAllInfoByStudentId =
  host + "jczl/api/new-student/admin/pseudoDeleteAllInfo/";
const pseudoDeleteAllInfoList =
  host + "jczl/api/new-student/admin/pseudoDeleteAllInfoList/";
const educationPermissionCheck =
  host + "jczl/api/new-student/admin/educationPermissionCheck/";
const selectVerifyRemark = host + "jczl/api/new-student/selectVerifyRemark/";
const selectSchoolNameAndId =
  host + "jczl/api/new-student/admin/selectSchoolNameAndId";
const assignSchool = host + "jczl/api/new-student/admin/assignSchool/";
const selectDeptList = host + "jczl/api/new-student/admin/selectDeptList/";
const selectAllEducationInfo =
  host + "jczl/api/new-student/admin/selectAllEducationInfo";
const exportExcelByMap = host + "jczl/api/new-student/admin/exportCsvByMap/";
// const exportExcelByMap= host +'jczl/api/new-student/admin/exportExcelByMap/'
const judgeCheckAuth = host + "jczl/api/new-student/admin/judgeCheckAuth/";
const setLandNumAuth = host + "jczl/api/new-student/admin/setLandNumAuth/";
const setLandNum = host + "jczl/api/new-student/admin/setLandNum/";
const selectApplicationDeleteInfo =
  host + "jczl/api/new-student/admin/selectApplicationDeleteInfo";
const exportCsvVerify = host + "jczl/api/new-student/admin/exportCsvVerify/";
const selectGraduationList =
  host + "jczl/api/new-student/admin/selectGraduationList/";
const insertNewStudentGraduation =
  host + "jczl/api/new-student/admin/insertNewStudentGraduation/";
const updateNewStudentGraduation =
  host + "jczl/api/new-student/admin/updateNewStudentGraduation/";
const deleteNewStudentGraduation =
  host + "jczl/api/new-student/admin/deleteNewStudentGraduation/";
const selectSchoolNameAndIdByUid =
  host + "jczl/api/new-student/admin/selectSchoolNameAndIdByUid/";
// 党员阵地，活动室
// 列表
const getselectMemberRoom = host + "jczl/api/party-room/selectMemberRoom/";
const getselectMemberPosition =
  host + "jczl/api/party-position/selectMemberPosition/";
// 新增
const getinsertMemberRoom = host + "jczl/api/party-room/insertMemberRoom";
const getinsertMemberPosition =
  host + "jczl/api/party-position/insertMemberPosition";
// 修改
const getupdateMemberRoom = host + "jczl/api/party-room/updateMemberRoom";
const getupdateMemberPosition =
  host + "jczl/api/party-position/updateMemberPosition";
// 删除
const getdeleteMemberRoom = host + "jczl/api/party-room/deleteMemberRoom/";
const getdeleteMemberPosition =
  host + "jczl/api/party-position/deleteMemberPosition/";

// 水电气暖的
const getwaterlist = host + "jczl/api/estate-life-business/list";
const getwaterdetail = host + "jczl/api/estate-life-business/transfer/detail";
const getwaterdelete = host + "jczl/api/estate-life-business/delete";
const getwatersenddata = orderNO =>
  host + `jczl/api/estate-life-business/${orderNO}/send-data`;
const getwatersave = host + "jczl/api/estate-life-business/transfer/save";
const getwaterexport = host + "jczl/api/estate-life-business/export";
const selectCompanyLifeBusiness =
  host + "jczl/api/estate-life-business/selectCompanyLifeBusiness";
const selectCompanyLifeBusinessDetails =
  host + "jczl/api/estate-life-business/selectCompanyLifeBusinessDetails/";
const handleCompanyLife =
  host + "jczl/api/estate-life-business/handleCompanyLife";

//不动产电子合同
const contract = host + "jczl/api/estate-collection/getAttachmentByUser";

//租赁合同
const fwzlxxList = host + "jczl/event/fwzlxx/list";
const delFwzlxx = host + "jczl/event/fwzlxx/del";
const getFwzlxx = host + "jczl/event/fwzlxx/get";
const invalidFwzlxx = host + "jczl/event/fwzlxx/invalid";
const saveFwzlxxDzzz = host + "jczl/event/fwzlxx/saveFwzlxxDzzz";

//打印编号
const estatePrintList = host + "jczl/api/estate-print/list4page";
const delEstatePrint = host + "jczl/api/estate-print/delete";
const saveEstatePrint = host + "jczl/api/estate-print/save";
const saveBatchEstatePrint = host + "jczl/api/estate-print/saveList";
//项目列表
const estateProjectList = host + "jczl/api/estate-project/list4page";
//不动产证书打印日志
const estatePrintLogList = host + "jczl/api/estate/printLogList";
const estatePrintLogDetail = host + "jczl/api/estate/printLogDetail";

//标准编码
const GetCodeByTypeforPhone = host + "base/base/Base_Datas/GetCodeByTypeforPhone"

const getEstateList = host + "jczl/api/estate/list";
const getselectGuardianEstateByCardno = host + "jczl/api/new-student/selectGuardianEstateByCardno";
const getJudicialDetail = host + "jczl/api/estate/detail/judicial";

// // //本地用
// // //热点
// const dx_rdfx = host + 'bigdata/bigData/BigdataHomepage/getMssqEventTypeSource'
// //专业网格
// const dx_zywg = host + 'bigdata/bigData/BigdataHomepage/getHomePageEvent'
// // 事件受理
// const dx_sjsl = host + 'bigdata/bigData/BigdataHomepage/getHomePageZHZFAcceptance'
// // 部门受理
// const dx_bmsl = host + 'bigdata/bigData/BigdataHomepage/getMssqAcceptanceFinish'
// // 实时动态
// const dx_ssdt = host + 'event/whistle/whistleevent/getEventByDx'

// // dl
// const dx_dl = host + 'upms/upms/login'
// const dx_jjfx = host + 'bigdata/bigData/HandanData/getCTQForty.ht'
// const dx_jjfxty = host + 'bigdata/bigData/HandanData/getCTQFortytechnology.ht'



// 社区报到
const getJczlRegistrationRecordPcList = host + "jczl/JczlRegistrationRecord/getPcList";
const registrationExportJczlRegistrationRecord = host + "jczl/JczlRegistrationRecord/registrationExport";//导出
// 社区报到审核
const reviewRecordJczlRegistrationRecord = host + "jczl/JczlRegistrationRecord/reviewRecord";
// 活动处理查询
const getPcListJczlActivityProcess = host + "jczl/JczlActivityProcess/getPcList";
const reviewProcessJczlActivityProcess = host + "jczl/JczlActivityProcess/reviewProcess";//活动处理审核
// 积分申报查询
const getPcListJczlScoreMove = host + "jczl/JczlScoreMove/getPcList";
const addDxScore = host + "jczl/api/score/addDxScore";//积分审核

const getScoreCount = host + "jczl/api/score/getScoreCount";//东乡积分管理接口
const getScoreExcel = host + "jczl/api/score/getScoreExcel";//东乡积分管理接口导出

// 社区报到人员名单
const listJczlRegistrationPersonnel = host + "jczl/JczlRegistrationPersonnel/list";
const delJczlRegistrationPersonnel = host + "jczl/JczlRegistrationPersonnel/del";
const saveJczlRegistrationPersonnel = host + "jczl/JczlRegistrationPersonnel/save";
const importRegistrationPersonnel = host + "jczl/JczlRegistrationPersonnel/importRegistrationPersonnel";//导入


const licenseUpload = host + "jczl/api/estate-order/licenseUpload";//濮阳承诺书1.0已领取[发送不动产审核]上传
export default {
  addDxScore,
  getScoreCount,
  licenseUpload,
  getScoreExcel,
  invalidFwzlxx,
  saveFwzlxxDzzz,
  listJczlRegistrationPersonnel,
  importRegistrationPersonnel,
  delJczlRegistrationPersonnel,
  saveJczlRegistrationPersonnel,
  registrationExportJczlRegistrationRecord,
  reviewRecordJczlRegistrationRecord,
  getJczlRegistrationRecordPcList,
  getPcListJczlActivityProcess,
  getPcListJczlScoreMove,
  reviewProcessJczlActivityProcess,
  GetCodeByTypeforPhone,
  handleCompanyLife,
  selectCompanyLifeBusinessDetails,
  selectCompanyLifeBusiness,
  getwaterexport,
  getwatersave,
  getwaterlist,
  getwaterdetail,
  getwaterdelete,
  getwatersenddata,
  getselectMemberRoom,
  getselectMemberPosition,
  getinsertMemberRoom,
  getinsertMemberPosition,
  getupdateMemberRoom,
  getupdateMemberPosition,
  getdeleteMemberRoom,
  getdeleteMemberPosition,

  selectAllCommitStudent,
  selectSignUpCommitInfo,
  selectSchoolInfo,
  insertNewStudentSchool,
  getselectAllInfo,
  getadminVerify,
  getadminVerifyList,
  getselectVerifyInfo,
  selectVerifyImage,
  deleteAllInfoByStudentId,
  pseudoDeleteAllInfoList,
  selectVerifyRemark,
  educationPermissionCheck,
  selectSchoolNameAndId,
  assignSchool,
  selectDeptList,
  selectAllEducationInfo,
  exportExcelByMap,
  judgeCheckAuth,
  setLandNumAuth,
  setLandNum,
  selectApplicationDeleteInfo,
  exportCsvVerify,
  selectGraduationList,
  insertNewStudentGraduation,
  updateNewStudentGraduation,
  deleteNewStudentGraduation,
  selectSchoolNameAndIdByUid,
  bbd_dp,
  dx_jjfxty,
  dx_jjfx,
  dx_dl,
  dx_rdfx,
  dx_zywg,
  dx_sjsl,
  dx_bmsl,
  dx_ssdt,
  ...pymonitor,
  checkCompanys,
  syncCommonTpyeDept,
  delManager,
  getUserList,
  addManager,
  getManagerList,
  delDept,
  addDept,
  getDeptTableList,
  login,
  get,
  checkManager,
  loginByQRcode,
  /* 获取保存行政区域 */
  register,
  /* 首页 */
  community,
  reply,
  getMenu,
  getQrParam,
  sendRandomByPhone,
  saveMenu,
  allAdmin,
  delAdmin,
  labelAdmin,
  saveAdmin,
  listmenuurl,
  uploadImg,
  getSysPic,
  deleteGzh,

  /* 用户管理  */
  // 居民
  addLabel,
  delLabel,
  updateUserAttr,
  resident,
  residentList,
  residentDetail,
  residentCheck,
  bindQrcode,
  sortToLabel,
  getUserStatics,
  getOrgAll,
  deletePeople,
  deleteUserZone,

  // 企业
  importFile,
  // 社工
  worker,
  workList,
  workerDetail,
  belongList,
  workerCheck,
  sortToWorkerLabel,
  /* 微支部微社区 */
  zonePic,
  zoneInfo,
  committeeInfo,
  zoneLeader,
  delLeader,
  zoneLabel,
  zoneList,
  zoneNoLeader,
  gridUser,
  stationUser,
  addStation,
  delStation,

  party,
  partyDelete,
  partyLabel,
  getDefaultPartyList,
  partyList,
  getPartyDetail,
  partyOne,
  partyTwo,

  partyUser,
  partyUserDelete,
  partyList4add,
  partyUserOrder,

  queryAuth,
  getauthurl,
  saveOrg,
  getsendList,
  getZone,
  saveSend,
  delSendImg,
  getSendInfo,
  delSend,
  Sortsend,
  sendArtical,
  deletePic,
  getAllZone,
  getfenlei,
  // erweima: host + 'wx/wechatgl/gzhguanli/getgzhbyinitid?initid=',
  erweima,
  /* 活动 */
  activitySend, // 添加修改活动
  getActivity, // 活动列表
  getActiveDetail, // 获取活动详情
  getActivityPeople, // 获取活动参与人
  getActivityPicList, // 获取活动图片列表
  people4unsign, // 查询没有签到的
  activitySign, // 活动签到
  delApplyOrSign, // 删除签到 或者报名
  saveActivityPic, // 保存或删除活动图片
  delActivityPic, // 删除活动图片
  getMessageList, // 获取留言列表
  saveMessage, // 活动回复保存
  delMessage, // 活动评论删除

  /* 社区统计 */
  activityCount, // 查询活动数量
  activitySignCount, // 签到报名总数
  scoreRank, // 积分排名
  activityCountExport,
  applySignCountExport,
  activityScoreExport,
  eventChart, // 事件统计
  eventChartExport,
  eventSatisfaction, // 事件满意度 统计
  eventSatisfactionExport,
  eventEfficiency, // 事件办事效率统计
  eventEfficiencyExport,

  downloadAttachment, // 下载附件
  delAttachment, // 删除附件
  downloadFile,
  downloadUserStatics,
  reloadQrcode,

  getOrg,
  getHistory,
  activeDel,
  getQyType,
  addQy,
  getQyList,
  delQy,
  getQyLabel,
  getJifen,
  submitJifen,
  submitBaifenbi,
  getPeopleList,
  delWzb,
  getQyDetail,
  getQyNature,
  getZoneProperty,
  getZoneEvent,
  getPartyActive,
  getService,
  getEcharts1,
  getEcharts2,
  getEcharts3,
  getChildShequ,
  getFeature,
  getHeatmap,
  getMiniSet,
  setMiniSet,
  getScoreList, // 获取积分详情
  sendAddScore, // 添加、修改积分
  delScore, // 删除补录积分
  getShowEvent,
  getProcess,
  getEvaluation,
  getShouye,
  getShouyeEc,
  getTvGonggao,
  getQyPingjia,
  getQyScore,
  delPingjia,
  /** 运行监控相关 */
  getCompany,
  getAreaAndStreet,
  getStreetPosition, // 查询所在街道和区
  getCommunityEvent,
  getPeopleEvent,
  getCompanyEvent, // 左侧事件办理
  eventIsShow, // 事件公示
  getPeopleEventList, // 左侧获取社工党员办理事件列表
  communityActivityList, // 右侧第一个图获取活动具体事件
  systemCount, // 中间今日概况
  communityActivityNum,
  communityEnrollNum,
  communityActive, // 右侧活动，活跃度
  /* 运行监控相关 -结束 */
  getDivision,
  shenheAll,
  delAll,
  getQrCode,

  /* 系统字典 */
  dictionaryList,
  getSqEvent,
  downSqsj,
  downQy,
  changePhone,
  getPhoneList,
  delPhone,

  getSqEventDetail,
  getEventDealPer,
  exportEventDealPer,
  canDownActCode,
  downActCode,

  /** 停车管理 */
  getParklingList,
  getParkingOptionList,
  saveParkingOption,
  deleteParkingInfo,
  exportData,
  deleteParkingOption,

  /** 投票 */
  getVoteList,
  deleteVote,
  newVote,
  voteCode,
  inviteCode,
  voteDetail,
  optionDetail,
  selPerson,
  selDetail,
  getHouse,
  downCitizen,
  importCitizen,
  downCitizenModel,

  getFiledConfig,
  fieldConfig,
  delConfig,
  getAuthDetail,
  setAuthDetail,

  /** 积分设置 */
  getJfRule,
  setJfRule,
  setAuthJf,

  getMstSetting,
  getSettingList,
  getModelDetail,
  getConnectModel,
  getModelIcon,
  addIcon,
  setStyle,
  sortList,
  setModule,
  getNoticeList,
  noticeSort,
  cancelNotice,
  delNotice,
  geiNoticeLink,
  getTemp,
  getNoticeDetail,
  getNoticeTag,
  newNotice,
  logOut,
  changeOrg,
  getOrganize,
  getOrgDetail,
  getOrgMember,
  getOrgAlbum,
  saveOrgPic,
  delOrgPic,
  delOrg,
  getOrgActive,
  getZhuban,
  getAllRealName,
  saveOrgMember,
  delOrgMember,
  orgShenhe,
  uploadFile,
  getWorker,
  completeMobile,
  completeFile,
  endMobile,
  qiangdan,
  eventToCompany,
  eventRedeploy,
  exportDetail,
  getReadPeople,
  sysNoticeList,
  readAll,
  sysNoticeDetail,
  assemblyList,
  delAss,
  assDetail,
  assembly,
  getOrgNumByCom,
  getGoodsLabel,
  getGoodsList,
  submitGood,
  getGoodDetail,
  getGoodQrcode,
  getExchangePeople,
  getGoodPeople,
  goodEchange,
  goodBulu,
  downGoodQrcode,
  exportGoodPeople,
  delGood,
  checkDownload,
  getQiyeType,
  getCompayType,
  getIndustryCategory,
  getDepList,
  getTypeDetail,
  getTypeIcon,
  addCompanyIcon,
  companyTypeSort,
  delCompanyType,
  addService,
  getActiveLabel,
  getPerson,
  addAd,
  getVanguard,
  getVanguardSelect,
  submitVanguard,
  getVanguardDetail,
  delVanguard,
  checkCompany,
  getAddCompany,
  getAdvert,
  getAdDetail,
  adSort,
  changeAdStatus,
  delAdvert,
  getAllAdvert,
  getAuth,
  applyRealname,
  getOrgList,
  getActPre,
  timelengthList,
  addTimeLength,
  delTimeLength,
  getQYType,
  getCTToken,
  getAppiontmentDefalut,
  submitAppointment,
  getAppointmentList,
  changeAppointmentStatus,
  delAppointment,
  getAppointmentDetail,
  getAppointmentDatedetail,
  tmentTimeSave,
  tmentDateSave,
  getTmentDate,
  tmentDateDel,
  getAppointmentUser,
  getAppointmentTime,
  changeUserAppointment,
  getAppointmentBanliDetail,
  uploadAppointmentUser,
  getMockToken,
  getModule,
  jczlAppointmentBlacklist,
  saveblacklist,
  delblacklist,
  getappointmentBlacklist,
  // 共享
  share_provider,
  share_getDetail,
  share_list,
  share_delete,
  share_resource,
  //共享结束
  dowloadFile,
  zhuanShequ,
  turnShequ,
  /**社区防疫 */
  getSterilzatioin,
  addSterilzatioin,
  getSupplies,
  addSupplies,
  getArea,
  getCity,
  submitPeople,
  getPeopleFangyiDetail,
  epidemicNotice,
  getFangyiList,
  delFangyiList,
  exportFangyiList,
  getFangyiDetail,
  getHealthyList,
  submitPeopleHealthy,
  delPeopleHealthy,
  getEpidemicSetting,
  exportHealthList,
  changeEpidemicSetting,
  checkPeople,
  exportPeopleCard,
  getFangyiNotice,
  downQrcode,
  getSysNotice,
  getSysNoticeDetail,
  getFangyiPeopleCardInfo,
  editFangyiHotline,
  importFangyi,
  fangyiChachong,
  chachongMerge,
  peopleLibraryList,
  exportLibrary,
  importLibrary,
  delLibrary,
  getLibraryDetail,
  changeLibrary,
  getWalkRecord,
  exportWalkReport,
  walkRecordDownload,
  //级联行政区域
  getCommunityCascade,
  //口罩预约开始
  getYuyueCompany,
  setYuyueConfig,
  getYuyueSettingList,
  getYuyueConfig,
  getYuyueList,
  getRound,
  searchPeopleInfo,
  addYuyueRecord,
  exportYuyueRecord,
  delRecordList,
  checkRecordPeople,
  //口罩预约结束
  /**补充引用 */
  zoneJobList,
  griderJobList,
  ownCommitteeJobList,
  committeeJobList,
  workerList4add,
  qyEmployeeList,
  qyEmployeeCheck,
  qyEmployeeDelete,
  qyEmployeeExport,
  /**补充引用结束 */

  /** 社区防疫大屏 **/
  getProviceShort,
  getEpidemicUserCount,
  getEpidemicUserList,
  getEpidemicFeverUser,
  getEpidemicHBMobilityTrends,
  getEpidemicUserInfo,
  getEpidemicTrendsStatistics,
  getEpidemicHealthStatistics,
  getEpidemicCommunityWalk,
  getEpidemicCompanyWalk,
  getEpidemicWalk,
  getPosition,
  /** 社区防疫大屏结束 **/
  getDeptList,
  people4list,
  people4export,
  demandNotice,
  demandNoticeList,
  // 网格
  gridList,
  addGrid,
  gridLevel,
  gridLabel,
  delGrid,
  getGridDetail,
  getGridUserList,
  addGridUser,
  delGridUser,
  gridCascade,
  // 业主委员会
  ownerCommitteeList,
  addOwnCommitteeNotice,
  getOwnCommiteeList,
  delOwnCommittee,
  deleteOwnCommitteeNOtice,
  ownCommiteeList,
  addOwnCommittee,
  // 社会保险记录
  ssList,
  ssExport,
  ssImport,
  ssDetail,
  ssDelete,
  // 承诺书
  PromiseList,
  PromiseReceive,
  download,
  download1,
  saveType,
  updateType,
  PromiseFileList,
  PromiseFileList1,
  PromiseFileList2,
  // 人脸认证记录
  faceVerifyList,
  dataCollectionList,
  dataCollectionExport,
  dataColectDetail,
  batchCheckLandTransfer,
  deleteCollectionBatch,
  artificialVerify,
  deathConfirm,
  deathRecover,
  taxInfoList,
  taxInfoDetail,
  updateInvoice,
  updateInvoiceList,
  invoice,
  getuser3list,
  saveHui,
  cancellation,
  regfeeExport,
  applyList,
  handleApply,
  updateAuditStatus,
  addApplyInfo,
  applyExport,
  importExcel,
  mailList,
  mailListDetail,
  updataMailInfo,
  mailListExport,
  taxQuery,
  birthCert,
  marriageRegister,
  rkMessVerification,
  swyxzmInfo,
  mzbJjhfr,
  gszjqyjbxxcx,
  gszjqyjbxxyz,
  bbSydwdqjg,
  qyjjjfpjxx,
  addPersonInspection,
  deletePersonInspection,
  exportPersonInspection,
  importPersonInspection,
  getPersonInspectionList,
  getPersonInspectionById,
  getWalkRecordList,
  exportWalkRecordList,
  applyDelete,
  // 首席服务员系列
  exportChiefWaiterExcel,
  getDicList,
  postChiefWaiterList,
  postChiefWaiter,
  postBatchAuditWaiter,
  postChiefWaiterEvaluateList,
  postChiefWaiterDocumentaryWork,
  getChiefWaiterDocumentaryWorkDetail,
  deleteChiefWaiter,
  getChiefWaiterDetail,
  hujicard,
  hujian,
  postChiefWaiterUserList,
  postRecordStatistic,
  postQuestionList,
  postEvaluateStatistic,
  exportRecordStatisticsExcel,
  exportQuestionListExcel,
  exportSelfStatisticsExcel,
  deleteWorkRecordOrWordSpecialClasses,
  postReplyWorkSpecialClasses,
  contract,
  fwzlxxList,
  delFwzlxx,
  getFwzlxx,
  estatePrintList,
  delEstatePrint,
  saveEstatePrint,
  saveBatchEstatePrint,
  estateProjectList,
  estatePrintLogList,
  estatePrintLogDetail,
  getEstateList,
  getselectGuardianEstateByCardno,
  getJudicialDetail,
  newborn,
  downloadNewborn,
  realName,
  realUpData,
  voteExport,
  listJczlbureaueducationidea,
  ideaExport
};
